import { Component } from '@angular/core';


interface Setting {
  key: string;
  value: any;
}

@Component({
  selector: 'app-billing',
  templateUrl: './billing.component.html',
  styleUrls: ['./billing.component.scss']
})
export class BillingComponent {

  constructor(
  ) {
  }

}
